import { defineStore } from 'pinia';
import currenciesJSON from "@/shared/assets/json/currencies.json";
import pricesJSON from "@/shared/assets/json/prices.json";
import { useLanguageStore } from "@/shared/stores/language.store";

export const useCurrencyStore = defineStore('currency', {
	state: () => ({
		prices: pricesJSON,
		currencies: currenciesJSON,
		currCountry: null
	}),
	getters: {
		langStore: () => useLanguageStore(),
		currCurrency: state => {
			let finalCurrency = null;
			if(state.currCountry) {
				for(let currency in state.currencies) {
					if(state.currencies[currency].countries.includes(state.currCountry)) {
						finalCurrency = state.currencies[currency];
						break;
					}

				}
			}
			return finalCurrency || state.currencies['eur'];
		},
		getCurrencyFromCode(state) {
			return (code) => {
				let finalCurrency = null;
				if (code && code?.toUpperCase) {
					for (let currency in state.currencies) {
						if (state.currencies[currency].code === code.toUpperCase()) {
							finalCurrency = state.currencies[currency];
							break;
						}
					}
				}
				return finalCurrency || this.currCurrency;
			}
		},
		currMinInteger() {
			let finalMinAmount = 1;
			if(this?.currCurrency?.hasOwnProperty('min_stripe_amount')) {
				finalMinAmount = Number(this.currCurrency.min_stripe_amount || 1);
			}
			return finalMinAmount;
		},
		readableCurrencyValue() {
			return (value, fromDb = true, withSymbol = true, noDecimals = false, customCurrencyCode = null) => {
				let currency = customCurrencyCode ? this.getCurrencyFromCode(customCurrencyCode) : this.currCurrency;
				let finalValue = !isNaN(value) ? value : 0;
				if(fromDb) {
					finalValue = this.dbToActualValue(finalValue, customCurrencyCode);
				}
				let numberStringOptions = {
					maximumFractionDigits: noDecimals ? 0 : currency.decimals,
					minimumFractionDigits: noDecimals ? 0 : currency.decimals
				}
				if(noDecimals) {
					numberStringOptions.roundingMode = "trunc";
				}
				let formattedValue = Number(finalValue || 0).toLocaleString([this.langStore.lang || "en"], numberStringOptions)
				let returnString = formattedValue;
				if(currency?.symbol && withSymbol) {
					returnString = currency?.symbol_position === 'before' ? currency.symbol +' '+ formattedValue : formattedValue +' '+ currency.symbol;
				}
				return returnString;
			}
		},
		dbToActualValue() {
			return (value, customCurrencyCode = null) => {
				let currency = customCurrencyCode ? this.getCurrencyFromCode(customCurrencyCode) : this.currCurrency;
				let multiplier = currency?.hasOwnProperty('multiplier') ? Number(currency.multiplier || 0) : 100;
				let decimals = currency?.hasOwnProperty('decimals') ? Number(currency.decimals || 0) : 2;
				let finalDbValue = !isNaN(value) ? Number(value) : 0;
				let finalValue = finalDbValue;
				if(!!multiplier && multiplier !== 1) {
					finalValue = Number(finalDbValue || 0) / multiplier;
				}
				return decimals === 0 ? Math.floor(finalValue) : Number(finalValue.toFixed(decimals));
			}
		},
		actualToDbValue: state => (value, customCurrencyCode = null) => {
			let currency = customCurrencyCode ? state.getCurrencyFromCode(customCurrencyCode) : state.currCurrency;
			let multiplier = currency?.hasOwnProperty('multiplier') ? Number(currency.multiplier || 0) : 100;
			let finalValue = !isNaN(value) ? Number(value || 0) : 0;
			if(!!multiplier && multiplier !== 1) {
				finalValue = finalValue * multiplier;
			}
			return Math.round(finalValue);
		},
		countryCurrency: state => country => {
			let finalCurrency = state.currencies['eur'];
			if(!country) {
				return finalCurrency;
			}
			for(let currency in state.currencies) {
				if(state.currencies[currency].countries.includes(country)) {
					finalCurrency = state.currencies[currency];
					break;
				}

			}
			return finalCurrency;
		},
		priceFromId(state) {
			return (priceId, customCurrencyCode) => {
				if(!priceId) { return null; }
				let currency = customCurrencyCode ? this.getCurrencyFromCode(customCurrencyCode) : this.currCurrency;
				let foundPrice = state.prices?.[priceId]?.[TEST ? "test" : "live"]?.[0];
				if(!foundPrice) {
					foundPrice = currency?.prices?.[priceId]?.[TEST ? "test" : "live"] || null;
				}
				return foundPrice;
			}
		},
	},
	actions: {
		initCurrency(countryCode) {
			this.currCountry = countryCode;
		}
	},
});
